//src/pages/EditarUsuario.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../axiosConfig";
import {
  ArrowLeft,
  CheckCircle2,
  Lock,
  Mail,
  Save,
  ShieldCheck,
  UserCog,
} from "lucide-react";

import "./EditarUsuario.css";

import { validarSenhaFrontend } from "../utils/senhaUtils";

function EditarUsuario() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState(null);
  const [novaSenha, setNovaSenha] = useState("");
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    const fetchUsuario = async () => {
      try {
        const res = await axios.get(`/usuarios-adm/${id}`);
        const data = res.data;

        const dadosTratados = {
          nome: data.nome || "",
          email: data.email || "",
          tipo: data.tipo || "admin",
          status: data.status || "ativo",
        };

        setUsuario(dadosTratados);
      } catch (err) {
        console.error("Erro ao buscar usuário:", err);
        alert("Erro ao buscar usuário. Ele pode não existir ou houve falha na conexão.");
        navigate("/usuarios");
      }
    };

    fetchUsuario();
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUsuario((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSalvar = async () => {
    const payload = { ...usuario };

    if (novaSenha) {
      const validacaoSenha = validarSenhaFrontend(novaSenha);

      if (!validacaoSenha.valida) {
        alert(validacaoSenha.mensagem);
        return;
      }

      payload.novaSenha = novaSenha;
    }

    try {
      setSalvando(true);
      await axios.put(`/usuarios-adm/${id}`, payload);
      navigate("/usuarios");
    } catch (err) {
      console.error("Erro ao atualizar usuário:", err);
      alert("Erro ao atualizar usuário.");
    } finally {
      setSalvando(false);
    }
  };

  if (!usuario) {
    return (
      <div className="editarUsuarioAdmin-state">
        <UserCog size={26} />
        <p>Carregando usuário...</p>
      </div>
    );
  }

  return (
    <div className="editarUsuarioAdmin-page">
      <div className="editarUsuarioAdmin-topbar">
        <div>
          <span className="editarUsuarioAdmin-kicker">Área administrativa</span>
          <h2>Editar usuário</h2>
          <p>
            Atualize os dados administrativos, status de acesso e, se necessário,
            defina uma nova senha para este usuário.
          </p>
        </div>

        <button
          type="button"
          className="editarUsuarioAdmin-btn secondary"
          onClick={() => navigate("/usuarios")}
        >
          <ArrowLeft size={16} />
          Voltar para usuários
        </button>
      </div>

      <div className="editarUsuarioAdmin-card">
        <div className="editarUsuarioAdmin-cardHeader">
          <div className="editarUsuarioAdmin-icon">
            <UserCog size={20} />
          </div>

          <div>
            <h3>Dados do usuário #{id}</h3>
            <span>Edite as informações principais de acesso ao painel.</span>
          </div>
        </div>

        <div className="editarUsuarioAdmin-form">
          <div className="editarUsuarioAdmin-field full">
            <label>Nome</label>

            <div className="editarUsuarioAdmin-inputIcon">
              <UserCog size={15} />
              <input
                name="nome"
                value={usuario.nome}
                onChange={handleChange}
                placeholder="Nome completo"
              />
            </div>
          </div>

          <div className="editarUsuarioAdmin-field full">
            <label>E-mail</label>

            <div className="editarUsuarioAdmin-inputIcon">
              <Mail size={15} />
              <input
                name="email"
                type="email"
                value={usuario.email}
                onChange={handleChange}
                placeholder="email@dominio.com.br"
              />
            </div>
          </div>

          <div className="editarUsuarioAdmin-field">
            <label>Tipo de usuário</label>

            <select name="tipo" value={usuario.tipo} onChange={handleChange}>
              <option value="admin">Admin</option>
              <option value="financeiro">Financeiro</option>
              <option value="comercial">Comercial</option>
              <option value="logistica">Logística</option>
            </select>
          </div>

          <div className="editarUsuarioAdmin-field">
            <label>Status</label>

            <select name="status" value={usuario.status} onChange={handleChange}>
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
            </select>
          </div>

          <div className="editarUsuarioAdmin-field full">
            <label>Nova senha opcional</label>

            <div className="editarUsuarioAdmin-inputIcon">
              <Lock size={15} />
              <input
                type="password"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                placeholder="Deixe em branco para não alterar"
              />
            </div>

            <small>
            Use pelo menos 8 caracteres, incluindo letras e números.
            Deixe em branco para manter a senha atual.
          </small>
          </div>
        </div>

        <div className="editarUsuarioAdmin-info">
          <ShieldCheck size={16} />
          <span>
            As permissões detalhadas deste usuário continuam sendo configuradas
            na tela específica de permissões.
          </span>
        </div>

        <div className="editarUsuarioAdmin-actions">
          <button
            type="button"
            className="editarUsuarioAdmin-btn secondary"
            onClick={() => navigate("/usuarios")}
          >
            <ArrowLeft size={16} />
            Voltar
          </button>

          <button
            type="button"
            className="editarUsuarioAdmin-btn primary"
            onClick={handleSalvar}
            disabled={salvando}
          >
            {salvando ? (
              <>
                <CheckCircle2 size={16} />
                Salvando...
              </>
            ) : (
              <>
                <Save size={16} />
                Salvar alterações
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditarUsuario;